// src/Components/Footer/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import bg from "../images/f2d-bg.png";
import logo from "../images/logo.png";

const Footer = () => {
  return (
    <footer
      className="py-5 mt-4"
      style={{
        backgroundImage: `linear-gradient(130deg, rgba(51, 105, 30, 0.35), rgba(51, 105, 30, 0.55))`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        color: "#352e0d", // deep earthy text
        fontSize: "0.9rem",
      }}
    >
      <div className="container">
        <div className="row gy-4">
          <div className="col-12 col-md-3">
            <h5 className="fw-bold mb-2">
              {" "}
              <img
                src={logo}
                alt="Logo"
                className="logo-img"
                style={{ height: "50px" }}
              />
              Uzhavan Supermart🍃
            </h5>
            <p className="mb-1">
              Your one-stop shop for organic and natural products.
            </p>
            <p className="small fst-italic">
              Freshness you can trust, from farm to family.
            </p>
          </div>

          <div className="col-6 col-md-3">
            <h6 className="fw-semibold mb-2">Quick Links</h6>
            <ul className="list-unstyled m-0 p-0">
              {/* <li className="mb-1">
                <Link
                  to="/"
                  className="text-decoration-none"
                  style={{ color: "#4b4112" }}
                >
                  Home
                </Link>
              </li> */}
              <li className="mb-1 ">
                <a
                  href="/"
                  className="text-decoration-none "
                  style={{ color: "#4b4112" }}
                >
                  Home
                </a>
              </li>
              <li className="mb-1 ">
                <a
                  href="#products"
                  className="text-decoration-none "
                  style={{ color: "#4b4112" }}
                >
                  Explore Now
                </a>
              </li>
              <li className="mb-1 ">
                <a
                  href="#contact"
                  className="text-decoration-none "
                  style={{ color: "#4b4112" }}
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="col-6 col-md-3">
            <h6 className="fw-semibold mb-2">Categories</h6>
            <ul className="list-unstyled m-0 p-0">
              <li className="mb-1 ">
                <a
                  href="#products"
                  className="text-decoration-none "
                  style={{ color: "#4b4112" }}
                >
                  Fruits
                </a>
              </li>

                <li className="mb-1 ">
                <a
                  href="#products"
                  className="text-decoration-none "
                  style={{ color: "#4b4112" }}
                >
                  Vegetables
                </a>
              </li>

                <li className="mb-1 ">
                <a
                  href="#products"
                  className="text-decoration-none "
                  style={{ color: "#4b4112" }}
                >
                  Oils
                </a>
              </li>
              
                <li className="mb-1 ">
                <a
                  href="#products"
                  className="text-decoration-none "
                  style={{ color: "#4b4112" }}
                >
                  Snacks
                </a>
              </li>
              
            </ul>
          </div>

          <div className="col-12 col-md-3">
            <h6 className="fw-semibold mb-2">Follow Us</h6>
            <div className="d-flex gap-3 mb-2">
              {/* <a
                href="#"
                aria-label="Facebook"
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: 36,
                  height: 36,
                  background: "rgba(255,255,255,0.1)",
                  color: "#fff",
                  textDecoration: "none",
                  transition: "transform .2s",
                }}
              >
                <FaFacebookF />
              </a> */}
              <a
                href="#"
                aria-label="Instagram"
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: 36,
                  height: 36,
                  background: "rgba(255,255,255,0.1)",
                  color: "#fff",
                  textDecoration: "none",
                  transition: "transform .2s",
                }}
              >
                <FaInstagram />
              </a>
              {/* <a
                href="#"
                aria-label="Twitter"
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: 36,
                  height: 36,
                  background: "rgba(255,255,255,0.1)",
                  color: "#fff",
                  textDecoration: "none",
                  transition: "transform .2s",
                }}
              >
                <FaTwitter />
              </a> */}
              <a
                href="#"
                aria-label="YouTube"
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: 36,
                  height: 36,
                  background: "rgba(255,255,255,0.1)",
                  color: "#fff",
                  textDecoration: "none",
                  transition: "transform .2s",
                }}
              >
                <FaYoutube />
              </a>
            </div>
            <p className="small mb-0">
              Follow us for recipes, deals, and behind-the-scenes from our
              farms.
            </p>
          </div>
        </div>

        {/* bottom bar */}
        <div
          className="mt-4 pt-3 border-top"
          style={{ borderColor: "rgba(255,255,255,0.15)" }}
        >
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
            <div className="mb-2 mb-md-0">
              <small>
                © {new Date().getFullYear()} Uzhavan Supermart. All rights
                reserved.
              </small>
            </div>
            <div>
              <small style={{ color: "#4b4112" }}>
                Crafted with care for organic living.
              </small>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
